import React, { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { Box } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import Spinner from '@atlaskit/spinner';

// To avoid a flash of content, only show the loading spinner if the page load
// is taking unreasonably long
export const SPINNER_APPEARANCE_DELAY = 2000;

const styles = cssMap({
	spinnerContainer: {
		position: 'fixed',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
	},
});

const i18n = defineMessages({
	loadingContent: {
		id: 'no-permission.loading-content',
		defaultMessage: 'Loading content',
		description: 'Accessible label for the loading spinner displayed when content is being loaded',
	},
});

export const ShowSpinnerAfterDelay = () => {
	const [isTooSoonToShowSpinner, setIsTooSoonToShowSpinner] = useState(true);
	const { formatMessage } = useIntl();
	useEffect(() => {
		void setTimeout(() => {
			setIsTooSoonToShowSpinner(false);
		}, SPINNER_APPEARANCE_DELAY);
	}, []);
	return isTooSoonToShowSpinner ? null : (
		<Box
			xcss={styles.spinnerContainer}
			role="progressbar"
			aria-label={formatMessage(i18n.loadingContent)}
		>
			<Spinner size="large" />
		</Box>
	);
};
